import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { ApiResponse, AuthService } from '@card-software/nexus-utilities';
import { ActivatedRoute, Router } from '@angular/router';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Observable, catchError, forkJoin, map, of } from 'rxjs';
import { Fabric } from '../../../models/fabric/fabric';
import { Greige, YarnDetail, FabricComposition } from '../../../models/greige/greige';
import { FabricProxyService } from '../../../proxies/item/fabric.proxy.service';
import { GreigeProxyService } from '../../../proxies/item/greige.proxy.service';
import { AssetProxyService } from '../../../proxies/asset/asset.proxy.service';
import { Yarn, YarnSearchSeveralRequest } from '../../../models/yarns/yarn';
import { PostSearch } from '../../../models/asset/search';
import { ProcessProxyService } from '../../../proxies/item/process.proxy.service';
import { FabricCategory } from '../../../models/fabric/fabricCategory';
import { FabricCategoryProxyService } from '../../../proxies/item/fabric-category.proxy.service';
import { Asset } from '../../../models/asset/asset';
import { EnumService } from '../../../services/enum.service';
import { BreadcrumbService, EnumValues, Note, UserLite, EnumObjectExtended } from '@card-software/library';
import { MasterData } from '@card-software/nexus-utilities';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { environment } from '../../../../environments/environment';
import _ from 'lodash';
import { UserAuthenticationService } from '../../../services/user-authentication.service';
import { Brand } from '../../../models/finance/brand';
import { Customer } from '../../../models/finance/customer';
import { Process } from '../../../models/engineering/process';
import { MasterDataActionUtil } from '../../../utilities/master-data-action-util';
import { GlobalMessageUtil, getLocalizedValue } from '@card-software/nexus-utilities';
import { BusinessProxyService } from '../../../proxies/finance/business.proxy.service';
import { BusinessEntityType } from '../../../models/finance/business';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditMasterdataDialogComponent } from '../../dialogs/edit-masterdata-dialog/edit-masterdata-dialog.component';
import { Translation } from '../../../models/Translations';
import { TranslateService } from '@ngx-translate/core';
import { FormControlInvalidFieldsUtil } from '../../../utilities/form-control-invalid-fields.util';
import {
  ProductDevelopmentAdminGroup,
  ProductDevelopmentEditorGroup,
  ProductDevelopmentViewerGroup,
} from '../../../models/authorization/enum/user-group.enum';
import { CommandSearchGreige } from '../../../models/greige/greige-search';

import { CompositionProxyService } from '../../../proxies/item/composition-proxy.service';
import { Composition } from '../../../models/composition/composition';
import { YarnProxyService } from '../../../proxies/item/yarn.proxy.service';
import { ProcessLossPercentageUtil } from '../../../utilities/process-loss-percentage.util';
import { ProductDevelopmentStatus, getValidStatusOptions } from '../../../models/enums/product-development-status';

@Component({
  selector: 'app-fabric-details',
  templateUrl: './fabric-details.component.html',
  styleUrls: ['./fabric-details.component.scss'],
  providers: [MessageService],
})
export class FabricDetailsComponent implements OnInit {
  ref: DynamicDialogRef | undefined;

  isLoading = 0;
  isEditing = false;
  allProcesses: Process[] = [];
  allBrands: Brand[] = [];
  allCustomers: Customer[] = [];

  // fabricProcessesIds: ProcessId[] = [];
  fabricId: string | null = null;
  fabric: Fabric | null = null;
  allGreiges: Greige[] = [];
  fabricCategories: FabricCategory[] = [];
  selectedGreige: Greige | null = null;
  notes: Note[] = [];
  userLite: UserLite | null = null;
  fabricForms: EnumValues;
  statuses: EnumValues;
  statusesEnum?: EnumObjectExtended;
  translations: Record<string, Translation> = {};
  formGroupSubmitted = false;
  // fabricForm Enum
  fabricFormOptions: { label: string; value: number }[] = [];
  finishAppearanceOptions: { label: string; value: number }[] = [];
  finishTypeOptions: { label: string; value: number }[] = [];
  handFeelTypesOptions: { label: string; value: number }[] = [];
  packingTypesOptions: { label: string; value: number }[] = [];
  //
  asset: Asset | null = null;
  rpm: number | null = null;

  yarnEntries: FormArray<FormGroup> = new FormArray<FormGroup>([]);

  yarnInfo = new FormGroup({
    yarnEntries: this.yarnEntries,
  });

  public allCompositions: Composition[] = [];
  commercialCompositionEntries: FormArray<FormGroup> = new FormArray<FormGroup>([]);
  // Tree nodes for each composition entry (indexed by entry index)
  compositionTreeNodes: Map<number, TreeNode[]> = new Map();
  //#region formControl declarations
  status: FormControl<number> = new FormControl<number>(0, {
    nonNullable: true,
    validators: Validators.required,
  });
  needleDropCode = new FormControl<string | null>(null);
  fabricForm = new FormControl<number | null>(null, Validators.required);
  dyeingAndFinishingLossPercentage = new FormControl<number | null>(null, [Validators.required, Validators.min(0.01), Validators.max(100)]);
  dyeingAndFinishingLossInternalPercentageControl = new FormControl<number>({
    value: 0,
    disabled: true,
  });
  fabricTypeCode: FormControl<FabricCategory | null> = new FormControl<FabricCategory | null>(null, Validators.required);
  gramsPerSquareMeter = new FormControl<number | null>(null, [Validators.required, Validators.min(1)]);
  endToEndWidth = new FormControl<number | null>(null, [Validators.required, Validators.min(1)]);
  longDescription = new FormControl<string | null>(null);
  greige: FormControl<Greige | null> = new FormControl<Greige | null>(null, Validators.required);
  brandReference = new FormControl<Brand | null>(null);
  customerReference = new FormControl<Customer | null>(null, Validators.required);
  customerNotes = new FormControl<string[]>([]);

  finishTypeCode = new FormControl<string | null>(null, Validators.required);
  finishAppearanceCode = new FormControl<string | null>(null, Validators.required);
  routeProcessIds = new FormControl<string[]>([], Validators.required);
  handFeelTypeCode = new FormControl<string | null>(null, Validators.required);
  packingTypeCode = new FormControl<string | null>(null, Validators.required);

  formGroup = new FormGroup({
    fabricTypeCode: this.fabricTypeCode,
    gramsPerSquareMeter: this.gramsPerSquareMeter,
    endToEndWidth: this.endToEndWidth,
    longDescription: this.longDescription,
    greige: this.greige,
    brandReference: this.brandReference,
    customerReference: this.customerReference,
    customerNotes: this.customerNotes,
    dyeingAndFinishingLossPercentage: this.dyeingAndFinishingLossPercentage,
    fabricForm: this.fabricForm,
    needleDropCode: this.needleDropCode,
    status: this.status as FormControl<number>, // status is not nullable
    finishingDetails: new FormGroup({
      finishTypeCode: this.finishTypeCode,
      finishAppearanceCode: this.finishAppearanceCode,
      handFeelTypeCode: this.handFeelTypeCode,
      packingTypeCode: this.packingTypeCode,
    }),
  });

  //#endregion

  aseetTypeCategoryId = environment.finishingAssetCategory; // Finishing Asset Category Id

  constructor(
    private assetService: AssetProxyService,
    private fabricCategoryProxyService: FabricCategoryProxyService,
    private fabricService: FabricProxyService,
    private getEnumService: EnumService,
    private greigeProxyService: GreigeProxyService,
    private messageService: MessageService,
    private processProxyService: ProcessProxyService,
    private route: ActivatedRoute,
    private router: Router,
    private yarnSearchService: YarnProxyService,
    private userAuthenticationService: UserAuthenticationService,
    private businessProxyService: BusinessProxyService,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private compositionProxyService: CompositionProxyService,
    private confirmationService: ConfirmationService,
    private breadcrumbService: BreadcrumbService,
  ) {
    this.userLite = this.userAuthenticationService.userLite;

    // set finishingDetails Enums
    this.statusesEnum = this.getEnumService.getEnum('ProductDevelopmentStatus', 'itemEnums');
    this.statuses = this.statusesEnum.values;
    // set fabricForm Enum
    this.fabricForms = this.getEnumService.getEnum('FabricForm', 'itemEnums').values;

    this.fabricFormOptions = this._setOptionsForPrimeNg(this.fabricForms);
    this.translations = {
      Error_Form_Invalid: {
        es: 'El formulario tiene campos inválidos. Por favor, complete todos los campos requeridos',
        en: 'Form has invalid fields. Please fill all required fields',
      },
      Fabric_No_Description: {
        es: 'Sin descripción',
        en: 'No description',
      },
    };
  }

  get finishingDetails(): FormGroup {
    return this.formGroup.get('finishingDetails') as FormGroup;
  }

  get needles(): number {
    const cylinderNeedles = this.asset?.knittingMachineDetails?.cylinderNeedles ?? 0;
    const dialNeedles = this.asset?.knittingMachineDetails?.dialNeedles ?? 0;
    return cylinderNeedles + dialNeedles;
  }

  canEdit() {
    // ReadyForProduction is immutable regardless of role (check saved status, not form value)
    const savedStatus = this.fabric?.status ?? null;
    if (savedStatus === ProductDevelopmentStatus.ReadyForProduction && this.fabricId !== 'new') {
      return false;
    }

    // if Admin or Editor
    if (AuthService.hasRole(ProductDevelopmentAdminGroup.FabricAdmin) || AuthService.hasRole(ProductDevelopmentEditorGroup.FabricEditor)) {
      return true;
    }
    // if Viewer
    if (AuthService.hasRole(ProductDevelopmentViewerGroup.FabricViewer)) {
      return false;
    }
    // Default
    return false;
  }

  /**
   * Gets the internal value as a percentage for display
   */
  get dyeingAndFinishingLossInternalPercentageDisplay(): number {
    const userPercentage = this.dyeingAndFinishingLossPercentage.value;
    if (!userPercentage || userPercentage <= 0) {
      return 0;
    }
    return ProcessLossPercentageUtil.getInternalPercentageDisplay(userPercentage);
  }

  /**
   * Gets the internal value to save to the database
   */
  get dyeingAndFinishingLossInternalValueForSave(): number {
    const userPercentage = this.dyeingAndFinishingLossPercentage.value;
    if (!userPercentage || userPercentage <= 0) {
      return 0;
    }
    return ProcessLossPercentageUtil.convertUserPercentageToDBValue(userPercentage);
  }

  ngOnInit(): void {
    // Update internal percentage display when user percentage changes
    this.dyeingAndFinishingLossPercentage.valueChanges.subscribe((userPercentage) => {
      const displayValue =
        userPercentage && userPercentage > 0 ? ProcessLossPercentageUtil.getInternalPercentageDisplay(userPercentage) : 0;
      this.dyeingAndFinishingLossInternalPercentageControl.setValue(displayValue, { emitEvent: false });
    });

    this.greige.valueChanges.subscribe((value) => {
      this.fabricTypeCode.setValue(null);
      this.asset = null;
      this.rpm = null;
      if (!_.isNil(value?.id)) {
        //Disable form by Rol
        if (!this.canEdit()) {
          this.fabricForm.disable();
          this.needleDropCode.disable();
        } else {
          this.fabricForm.enable();
          this.needleDropCode.enable();
        }

        this.getMachineInfoAndYarn(value);
        this.fabricTypeCode.setValue(this.fabricCategories.find((fc) => fc.code === value.fabricPrefix) ?? null);
      } else {
        this.needleDropCode.setValue(null);
        this.needleDropCode.disable();
        this.fabricForm.setValue(null);
        this.fabricForm.disable();
      }
    });

    this.isLoading++;

    forkJoin({
      fabricCategories: this.fabricCategoryProxyService.getFabricCategories(),
      processes: this.processProxyService.searchProcesses({
        showInFabricGeneralProcessRoute: true,
      }),
      processTypes: this.processProxyService.getProcessTypes(),
      greiges: this.greigeProxyService.getAllGreiges(),
      businesses: this.businessProxyService.search({
        businessTypes: [BusinessEntityType.Brand, BusinessEntityType.Client],
      }),
      compositions: this.compositionProxyService.getAllCompositions(),
    }).subscribe({
      next: ({ fabricCategories, processes, greiges, businesses, compositions }) => {
        this.isLoading--;
        this.allCompositions = compositions.data ?? [];
        this.allProcesses = processes.data ?? [];
        this.fabricCategories = fabricCategories.data ?? [];
        this.allGreiges = greiges.data ?? [];
        this.allBrands = businesses?.data?.items?.filter((b) => b.businessTypes?.includes(BusinessEntityType.Brand)) || [];
        this.allCustomers = businesses?.data?.items?.filter((c) => c.businessTypes?.includes(BusinessEntityType.Client)) || [];
        this.route.queryParams.subscribe((params) => {
          this.fabricId = params['id'];
          if (!this.fabricId) {
            this.router.navigate(['/fabric']);
            return;
          }
          this.isLoading++;
          if (this.fabricId === 'new') {
            this.isEditing = false;
            this.breadcrumbService.setCurrent('Common_New');
            this.formGroup.reset();
            this.isLoading = 0;
          } else {
            this.isEditing = true;
            this.loadFabric(this.fabricId);
          }
        });
      },
      error: (e) => {
        this.isLoading--;
        console.error('Error fetching processes and process types', e);
      },
    });
    //Disable form by Rol
    if (!this.canEdit()) {
      this.formGroup.disable();
    }
  }

  getLongDescription(): string {
    if (!this.greige.value?.longDescription)
      return this.translations['Fabric_No_Description'][this.translateService.currentLang as keyof Translation];
    return this.greige.value?.longDescription + ' ' + this.gramsPerSquareMeter.value + '/' + this.endToEndWidth.value;
  }

  handleDelete(event: { item: MasterData; confirmCallback: () => void; cancelCallback: () => void }) {
    MasterDataActionUtil.attemptToDeleteMasterData(event.item).subscribe({
      next: (confirmed) => {
        if (confirmed) {
          event.confirmCallback();
        } else {
          event.cancelCallback();
        }
      },
    });
  }

  handleUpdate(event: { item: MasterData; confirmCallback: (item: MasterData) => void; cancelCallback: () => void }) {
    this.ref = this.dialogService.open(EditMasterdataDialogComponent, {
      header: `Edit ${event.item.name}`,
      modal: true,
      closable: true,
      width: '400px',
      height: 'auto',
      data: {
        item: event.item,
        confirmCallback: event.confirmCallback,
        cancelCallback: event.cancelCallback,
      },
    });

    this.ref.onClose.subscribe((result: MasterData | null) => {
      if (result) {
        event.confirmCallback?.(result);
      } else {
        event.cancelCallback?.();
      }
    });
  }

  showMessagesApi(event: ApiResponse<MasterData>) {
    if (event.success) {
      GlobalMessageUtil.success('Success', this.translateService.instant('Fabric_Message_API_Success'));
    } else {
      GlobalMessageUtil.error(
        'Error',
        (typeof event.errorMessage === 'string' ? event.errorMessage : getLocalizedValue(this.translateService, event.errorMessage)) ||
          this.translateService.instant('Fabric_Message_API_Error'),
      );
    }
  }

  loadFabric(id: string): void {
    this.fabricService.getFabricById(id).subscribe({
      next: (fabricResponse) => {
        this.fabric = fabricResponse.data;
        this.breadcrumbService.setCurrent(this.fabric?.fabricCode);
        const fabric = fabricResponse.data;
        const greige = fabric?.greige;
        if (_.isNil(fabric)) {
          console.error('Fabric is null or undefined');
          return;
        }
        if (_.isNil(greige)) {
          console.error('Fabric is null or undefined');
          return;
        }
        this.fabricForm.setValue(fabric.fabricForm);
        this.needleDropCode.setValue(fabric.needleDropCode ?? null);
        // Convert internal value to user percentage when loading
        const dbValue = fabric.finishingDetails?.dyeingAndFinishingLossPercentage ?? 0;
        const userPercentage = dbValue > 0 ? ProcessLossPercentageUtil.convertDBValueToUserPercentage(dbValue) : 0;
        this.dyeingAndFinishingLossPercentage.setValue(userPercentage);
        // Update internal percentage display
        const displayValue = userPercentage > 0 ? dbValue : 0;
        this.dyeingAndFinishingLossInternalPercentageControl.setValue(displayValue);
        this.status.setValue(this.fabric?.status ?? 0);
        this.notes = fabricResponse.data?.notes || [];
        greige.fieldToDisplay = `${greige.greigeCode} - ${greige.longDescription} ${this.getLoopLengthsDisplay(greige)}`;
        this.greige.setValue(greige);

        // Use saved commercialCompositions if available, otherwise use greige composition
        if (fabric.commercialCompositions && fabric.commercialCompositions.length > 0) {
          this.loadCommercialCompositions(fabric.commercialCompositions);
        } else {
          this.createNewCompositionFormGroup(greige);
        }

        this.formGroup.patchValue({
          longDescription: this.fabric?.longDescription || '',
          endToEndWidth: this.fabric?.endToEndWidth,
          gramsPerSquareMeter: this.fabric?.gramsPerSquareMeter,
        });
        this.brandReference.setValue(this.allBrands.find((brand) => brand.id === this.fabric?.brandReference) || null, {
          emitEvent: false,
        });

        this.customerReference.setValue(this.allCustomers.find((customer) => customer.id === this.fabric?.customerReference) || null, {
          emitEvent: false,
        });

        if (this.fabric?.finishingDetails) {
          this.finishingDetails.patchValue({
            finishTypeCode: this.fabric.finishingDetails.finishTypeCode,
            finishAppearanceCode: this.fabric.finishingDetails.finishAppearanceCode,
            handFeelTypeCode: this.fabric.finishingDetails.handFeelTypeCode,
            packingTypeCode: this.fabric.finishingDetails.packingTypeCode,
          });
          this.routeProcessIds.setValue(this.fabric.finishingDetails?.routeProcessIds || []);
        }

        // Re-check canEdit after fabric is loaded (savedStatus is now available)
        if (!this.canEdit()) {
          this.formGroup.disable();
          this.routeProcessIds.disable();
          this.commercialCompositionEntries.controls.forEach((c) => c.disable());
          this.dyeingAndFinishingLossPercentage.disable();
        }

        this.isLoading--;
      },
      error: () => {
        this.isLoading--;
        this.router.navigate(['/greiges']);
      },
    });
  }

  get convertLbsToYards(): string {
    if (!this.endToEndWidth?.value || !this.gramsPerSquareMeter?.value || _.isNil(this.fabricForm.value)) return '';
    const factor1 = 288;
    const factor2 = 33.906;
    let ydsLbs = 0;

    const divider = this.fabricForm.value === 0 ? this.endToEndWidth.value / 2 : this.endToEndWidth.value;

    ydsLbs = (1 / (this.gramsPerSquareMeter.value / factor2)) * (factor1 / divider);
    ydsLbs = parseFloat(ydsLbs.toFixed(3));

    return this.formatYardsAndInches(ydsLbs);
  }

  private formatYardsAndInches(yards: number): string {
    const decimalYards = yards.toFixed(3);
    const decimalPart = `${decimalYards} yd`;

    const wholeYards = Math.floor(yards);
    const fractionalYards = yards - wholeYards;
    const inches = Math.round(fractionalYards * 36);

    let yardsInchesPart = '';
    if (wholeYards > 0 && inches > 0) {
      yardsInchesPart = `${wholeYards} yd ${inches} in`;
    } else if (wholeYards > 0) {
      yardsInchesPart = `${wholeYards} yd`;
    } else if (inches > 0) {
      yardsInchesPart = `${inches} in`;
    } else {
      yardsInchesPart = '0 yd';
    }

    return `${decimalPart} • ${yardsInchesPart}`;
  }

  getMachineInfoAndYarn(greige: Greige) {
    const machineInfo = greige.machineInformation;
    if (!machineInfo) return;
    const assetReqBody: PostSearch = {
      assetId: machineInfo.assetId,
    };
    const yarnRequests = greige.yarnDetails.map((yd) => {
      const bodySearchYarn: YarnSearchSeveralRequest = {
        code: yd.yarnCode ?? '',
        dataBaseName: '',
      };
      return this.yarnSearchService.searchSeveral(bodySearchYarn);
    });

    this.isLoading++;
    forkJoin({
      asset: this.assetService.searchByAssetId(assetReqBody),
      yarns: forkJoin(yarnRequests),
    }).subscribe({
      next: ({ asset, yarns }) => {
        const allYarns = yarns.flat()[0].data?.flat() ?? [];
        this.asset = asset?.data!.items[0];
        this.populateYarnArray(allYarns, this.greige?.value?.yarnDetails ?? []);
        this.isLoading--;
      },
      error: (e) => {
        this.isLoading--;
        console.error('Error fetching machine/yarn info', e);
      },
    });
  }

  createYarnFormGroup(item: Yarn, yarnDetail: YarnDetail): FormGroup {
    return new FormGroup({
      selectedYarn: new FormControl({ value: item, disabled: true }),
      yarnPosition: new FormControl({
        value: yarnDetail.yarnPosition,
        disabled: true,
      }),
      loopLength: new FormControl(yarnDetail.loopLength),
      loopsPerNeedle: new FormControl(yarnDetail.loopsPerNeedle),
      cones: new FormControl(yarnDetail.cones),
      usePercentage: new FormControl(yarnDetail.usePercentage),
      mtsRev: new FormControl(yarnDetail.metersPerRevolution),
      kgRev: new FormControl(yarnDetail.kilogramsPerRevolution),
      lbsRev: new FormControl(yarnDetail.kilogramsPerRevolution ? yarnDetail.kilogramsPerRevolution / 2.20462 : 0),
      count: new FormControl(item.yarnCount),
    });
  }

  createNewCompositionFormGroup(greige: Greige): void {
    this.commercialCompositionEntries.clear();
    this.compositionTreeNodes.clear();

    if (!greige.fabricComposition || greige.fabricComposition.length === 0) {
      return;
    }

    greige.fabricComposition.forEach((comp) => {
      this.addCompositionEntry(comp.compositionCode, comp.percentage);
    });
  }

  loadCommercialCompositions(compositions: FabricComposition[]): void {
    this.commercialCompositionEntries.clear();
    this.compositionTreeNodes.clear();

    if (!compositions || compositions.length === 0) {
      return;
    }

    compositions.forEach((comp) => {
      this.addCompositionEntry(comp.compositionCode, comp.percentage);
    });
  }

  private addCompositionEntry(compositionCode: string, percentage: number): void {
    const index = this.commercialCompositionEntries.length;

    // Build tree nodes for this composition entry
    const treeNodes = this.buildCompositionTreeNodes(compositionCode);
    this.compositionTreeNodes.set(index, treeNodes);

    // Find the selected node for the current composition code
    const selectedNode = this.findNodeByCode(treeNodes, compositionCode);

    const formGroup = new FormGroup({
      compositionCode: new FormControl(compositionCode, [Validators.required]),
      selectedNode: new FormControl<TreeNode | null>(selectedNode),
      percentage: new FormControl(percentage, [Validators.required, Validators.min(0.01), Validators.max(100)]),
    });

    // Sync selectedNode changes to compositionCode
    formGroup.get('selectedNode')?.valueChanges.subscribe((node: TreeNode | null) => {
      if (node?.data) {
        formGroup.get('compositionCode')?.setValue(node.data, { emitEvent: false });
      }
    });

    if (!this.canEdit()) {
      formGroup.disable();
    }

    this.commercialCompositionEntries.push(formGroup);
  }

  /**
   * Build tree nodes for a composition, showing only the family (parent + siblings)
   * that the original greige composition belongs to.
   */
  private buildCompositionTreeNodes(originalCompositionCode: string): TreeNode[] {
    // Find the composition by code
    const composition = this.allCompositions.find((c) => c.code?.toLowerCase() === originalCompositionCode.toLowerCase());

    if (!composition) {
      return [];
    }

    // Determine the parent code - if this is a child, use its parentCode; if it's a parent, use its own code
    const parentCode = composition.parentCode || composition.code;

    // Find the parent composition
    const parentComposition = composition.parentCode ? this.allCompositions.find((c) => c.code === parentCode) : composition;

    if (!parentComposition) {
      return [];
    }

    // Find all children of this parent
    const children = this.allCompositions.filter((c) => c.parentCode === parentComposition.code);

    // Build the tree structure
    const childNodes: TreeNode[] = children.map((child) => ({
      key: child.code,
      label: child.name?.en || child.code || '',
      data: child.code,
      selectable: true,
    }));

    // Parent node with children - parent is always selectable
    const parentNode: TreeNode = {
      key: parentComposition.code,
      label: parentComposition.name?.en || parentComposition.code || '',
      data: parentComposition.code,
      selectable: true,
      expanded: true,
      children: childNodes.length > 0 ? childNodes : undefined,
    };

    return [parentNode];
  }

  /**
   * Find a TreeNode by its code (data field)
   */
  private findNodeByCode(nodes: TreeNode[], code: string): TreeNode | null {
    for (const node of nodes) {
      if (node.data === code) {
        return node;
      }
      if (node.children) {
        const found = this.findNodeByCode(node.children, code);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  /**
   * Get tree nodes for a specific composition entry index
   */
  getCompositionTreeNodesForEntry(index: number): TreeNode[] {
    return this.compositionTreeNodes.get(index) || [];
  }

  getTotalCommercialCompositionPercentage(): number {
    return this.commercialCompositionEntries.controls.reduce((sum, entry) => {
      return sum + (entry.get('percentage')?.value || 0);
    }, 0);
  }

  isCommercialCompositionPercentageValid(): boolean {
    return Math.abs(this.getTotalCommercialCompositionPercentage() - 100) <= 0.01;
  }

  getCompositionOptions(): { label: string; value: string }[] {
    const sortedCompositions = this.allCompositions.sort((a, b) => {
      const nameA = a.name?.en || a.code || '';
      const nameB = b.name?.en || b.code || '';
      return nameA.localeCompare(nameB);
    });
    return sortedCompositions.map((comp) => ({
      label: comp.name?.en || comp.code || '',
      value: comp.code || '',
    }));
  }

  getCommercialDisplayName(): string {
    const fabricCategoryName = this.fabricTypeCode.value?.name?.en || '';
    const compositionSummary = this.getCompositionSummary();
    const gsm = this.gramsPerSquareMeter.value || '';
    const width = this.endToEndWidth.value || '';

    const parts: string[] = [];

    if (fabricCategoryName) {
      parts.push(fabricCategoryName);
    }

    if (compositionSummary) {
      parts.push(compositionSummary);
    }

    if (gsm && width) {
      parts.push(`${gsm}/${width}`);
    } else if (gsm) {
      parts.push(`${gsm}`);
    } else if (width) {
      parts.push(`${width}`);
    }

    return parts.join(' ');
  }

  getCompositionSummary(): string {
    const entries = this.commercialCompositionEntries.controls;
    if (entries.length === 0) return '';

    return [...entries]
      .sort((a, b) => {
        const percentageA = a.get('percentage')?.value ?? 0;
        const percentageB = b.get('percentage')?.value ?? 0;
        return percentageB - percentageA;
      })
      .map((entry) => {
        const code = entry.get('compositionCode')?.value;
        const percentage = entry.get('percentage')?.value;
        const composition = this.allCompositions.find((c) => c.code?.toLowerCase() === code?.toLowerCase());
        const name = composition?.name?.en || code || '';
        return `${percentage}% ${name}`;
      })
      .join(' ');
  }

  populateYarnArray(yarnList: Yarn[], yarnDetails: YarnDetail[]): void {
    this.yarnEntries.clear();

    yarnList.forEach((yItem) => {
      const yDetail = yarnDetails.find(
        (yd) => yd.yarnCode === yItem.code,
        // yd.articleCode === yItem.articleCode.toString() &&
        // yd.responsebaseName === yItem.responseBaseName,
      );
      const fg = this.createYarnFormGroup(yItem, yDetail ?? {});
      this.yarnEntries.push(fg);
    });
  }

  greigeTypeAhead = (term: string) => {
    if (!term) return of([]);
    const filtered = this.allGreiges.filter((g) => g.greigeCode!.toLowerCase().includes(term.toLowerCase()));
    return of(filtered);
  };

  public fetchGreiges = (query: string): Observable<Greige[]> => {
    const commmand: CommandSearchGreige = {
      greigeCode: query,
      longDescription: query,
    };

    return this.greigeProxyService.searchGreigeAnyMatch(commmand).pipe(
      map((greiges) =>
        (greiges.data?.items ?? []).map((g) => ({
          ...g,
          fieldToDisplay: `${g.greigeCode} - ${g.longDescription} ${this.getLoopLengthsDisplay(g)}`,
        })),
      ),
      catchError(() => of([] as Greige[])),
    );
  };

  public onSave(): void {
    this.formGroupSubmitted = true;
    console.log('formgroup invalids', FormControlInvalidFieldsUtil.getInvalidControls(this.formGroup));
    if (this.formGroup.valid) {
      // Confirm if transitioning to ReadyForProduction
      if (
        this.status.value === ProductDevelopmentStatus.ReadyForProduction &&
        this.fabric?.status !== ProductDevelopmentStatus.ReadyForProduction
      ) {
        this.confirmationService.confirm({
          key: 'main',
          header: this.translateService.instant('Common_Confirmation'),
          icon: 'pi pi-exclamation-triangle',
          message:
            this.translateService.instant('Fabric_ReadyForProduction_Confirmation') ||
            'This will set the fabric to Ready for Production and Customer Service will be able to create a Work Order. This action cannot be undone.',
          rejectLabel: this.translateService.instant('Common_Cancel'),
          rejectButtonProps: {
            label: this.translateService.instant('Common_Cancel'),
            severity: 'secondary',
            outlined: true,
          },
          acceptButtonProps: {
            label: this.translateService.instant('Common_Accept'),
          },
          accept: () => {
            this.executeSave();
          },
        });
        return;
      }

      this.executeSave();
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: this.translations['Error_Form_Invalid'][this.translateService.currentLang as keyof Translation],
        life: 2500,
        key: 'br',
      });
    }
  }

  private executeSave(): void {
    const updatedFabric: Fabric = {
      id: this.fabric ? this.fabric.id : undefined,
      aliases: this.fabric ? this.fabric.aliases : [],
      status: this.status.value ?? 0,
      fabricCode: this.fabric ? this.fabric.fabricCode : undefined,
      fabricTypeCode: this.fabricTypeCode?.value?.code ?? '',
      gramsPerSquareMeter: this.gramsPerSquareMeter.value ?? 0,
      endToEndWidth: this.endToEndWidth.value ?? 0,
      longDescription: this.longDescription.value ?? '',
      greigeReference: this.greige.value?.id ?? '',
      brandReference: this.brandReference.value?.id ?? undefined,
      customerReference: this.customerReference.value?.id ?? '',
      notes: this.notes,
      needleDropCode: this.fabricForm.value == 0 ? (this.needleDropCode.value ?? undefined) : undefined,
      fabricForm: this.fabricForm.value ?? 0,
      commercialCompositions: this.commercialCompositionEntries.controls.map((entry) => ({
        compositionCode: entry.get('compositionCode')?.value,
        percentage: entry.get('percentage')?.value,
      })),
      finishingDetails: {
        finishTypeCode: this.finishTypeCode.value!,
        finishAppearanceCode: this.finishAppearanceCode.value!,
        routeProcessIds: this.routeProcessIds.value ?? [],
        handFeelTypeCode: this.handFeelTypeCode.value!,
        packingTypeCode: this.packingTypeCode.value!,
        dyeingAndFinishingLossPercentage: this.dyeingAndFinishingLossInternalValueForSave,
      },
    };

    const payload = updatedFabric;

    this.isLoading++;
    if (updatedFabric.id && updatedFabric.id !== 'new') {
      this.fabricService.updateFabric(updatedFabric.id, payload).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: this.translateService.instant('Fabric_Updated_Successfully').replace('{{name}}', updatedFabric.fabricCode ?? ''),
            life: 3000,
            key: 'br',
          });
          this.isLoading--;
          setTimeout(() => {
            this.router.navigate(['/fabric']);
          }, 1500);
        },
      });
    } else {
      this.fabricService.createFabric(updatedFabric).subscribe({
        next: (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: this.translateService.instant('Fabric_Created_Successfully').replace('{{name}}', response.data?.fabricCode ?? ''),
            life: 2500,
            key: 'br',
          });
          this.isLoading--;
          setTimeout(() => {
            this.router.navigate(['/fabric']);
          }, 1500);
        },
      });
    }
    this.formGroupSubmitted = false;
  }

  onCancel(): void {
    this.router.navigate(['/fabric']);
  }

  getProcessCount(processIdN: number): number {
    const processId = String(processIdN); // Ensure processId is a string
    return _.countBy(this.routeProcessIds.value || [])[processId] || 0;
  }

  addProcessToFinishingRoute(processIdN: number) {
    const processId = String(processIdN); // Ensure processId is a string
    this.routeProcessIds.setValue([...(this.routeProcessIds.value || []), processId]);
  }

  getProcesses(): Process[] {
    const processes: Process[] = [];
    this.routeProcessIds.value?.forEach((processId) => {
      const process = this.allProcesses.find((p) => p.processId === Number(processId));
      if (process) {
        processes.push(process);
      }
    });
    return processes;
  }

  translateProcesses(procesesName: string) {
    return this.translateService.instant(procesesName);
  }

  removeProcessToFinishingRoute(processIdN: number) {
    const processId = String(processIdN);
    const processIds = this.routeProcessIds.value || [];

    const duplicatedProcessIndices: number[] = [];

    processIds.filter((p, index) => {
      // Get indices of proccessId and put in to an array
      if (p === processId) {
        duplicatedProcessIndices.push(index);
      }
    });

    const processToRemove = Math.max(...duplicatedProcessIndices); // get the index of the last selected processId

    if (processToRemove > -1) {
      // only splice array when item is found
      processIds.splice(processToRemove, 1); // 2nd parameter means remove one item only
    }

    this.routeProcessIds.setValue(processIds);
  }

  // also update the order of the assetTypesIds
  dropProcess(event: CdkDragDrop<[]>) {
    const processIds = this.routeProcessIds.value || [];
    moveItemInArray(processIds, event.previousIndex, event.currentIndex);
    this.routeProcessIds.setValue(processIds);
  }

  public _setOptionsForPrimeNg(value: EnumValues) {
    return Object.keys(value).map((key) => {
      const numKey = parseInt(key);
      return {
        label: value[numKey],
        value: numKey,
      };
    });
  }

  get fileName() {
    return this.greige.value?.knittingGraphDocuments?.name.split('/').pop();
  }
  downloadFile() {
    window.open(this.greige.value?.knittingGraphDocuments?.presignedUrl, '_blank');
  }

  brandTypeTypeahead = (term: string): Observable<Brand[]> => {
    const filtered = this.allBrands.filter((brand) => brand!.name!.toLowerCase().includes(term.toLowerCase()));
    return of(filtered);
  };

  customerTypeTypeahead = (term: string): Observable<Customer[]> => {
    const filtered = this.allCustomers.filter((customer) => customer!.name!.toLowerCase().includes(term.toLowerCase()));
    return of(filtered);
  };

  public get fabricStatusOptions(): EnumValues {
    if (!this.statuses || typeof this.statuses !== 'object') return {};
    if (!this.canEdit() && this.status.value !== ProductDevelopmentStatus.ReadyForProduction) return {};

    // Admins and Editors with edit capability: show valid next statuses
    if (AuthService.hasRole(ProductDevelopmentAdminGroup.FabricAdmin) || AuthService.hasRole(ProductDevelopmentEditorGroup.FabricEditor)) {
      const savedStatus = this.fabric?.status ?? ProductDevelopmentStatus.Draft;
      return getValidStatusOptions(savedStatus, this.statuses);
    }

    return {};
  }

  goToInternalLink(linkType?: string): void {
    let url: string;

    if (linkType === 'process-loss') {
      url = 'https://scribehow.com/shared/Creating_a_Process_for_Fabric_Route_In_Sierra_ERP__VKHDfUWeQ8-X21SDR-cKwQ';
    } else {
      // Default link for fabric creation
      url = 'https://scribehow.com/shared/How_To_Add_A_New_Fabric_In_Sierra_ERP__7NtUW6XRRTeZKq4MewHtjQ';
    }

    window.open(url, '_blank');
  }

  getGreigeStatusLabel(status: number): string {
    return this.statuses[status] ?? '';
  }

  getGreigeStatusSeverity(status: number): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' {
    switch (status) {
      case 4:
        return 'success'; // ReadyForProduction
      case 3:
        return 'info'; // Approved
      case 2:
        return 'warn'; // UnderReview
      case 1:
        return 'secondary'; // InDevelopment
      case 0:
        return 'contrast'; // Draft
      case 98:
        return 'danger'; // Inactive
      case 99:
        return 'danger'; // Rejected
      default:
        return 'secondary';
    }
  }

  navigateToGreige(greigeId: string): void {
    if (!greigeId) return;
    const urlTree = this.router.createUrlTree(['/greige-details'], {
      queryParams: { id: greigeId },
    });
    window.open(this.router.serializeUrl(urlTree), '_blank');
  }

  getLoopLengthsDisplay(greige: Greige): string {
    if (!greige.yarnDetails || greige.yarnDetails.length === 0) {
      return '[]';
    }

    const loopLengths = greige.yarnDetails
      .map((yarn) => yarn.loopLength)
      .filter((loopLength) => loopLength !== null && loopLength !== undefined);

    return `[${loopLengths.join(', ')}]`;
  }
}
